/**
 * Tisha — sticky bar / floating widgets footer collision fix
 *
 * When footer enters viewport, hide:
 *   - .tp-sticky-bar / .th-sticky-bar (Add to Cart bottom bar)
 *   - Microsoft Clarity Shopping Agent ("Shop with AI" badge)
 * so they don't cover footer policy / contact links.
 */
(function(){
  function findFooter(){
    return document.querySelector('footer, .tisha-footer, [data-section-type="footer"], .footer-group, #shopify-section-footer-group');
  }

  function init(){
    var footer = findFooter();
    if(!footer) {
      // try later — section may be loaded async
      return setTimeout(init, 800);
    }

    var hideTargets = [
      '.tp-sticky-bar',
      '.th-sticky-bar',
      '[data-testid="entrypoint"][aria-label="Shopping Agent"]',
    ];

    function applyState(hide){
      hideTargets.forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(el){
          if(hide){
            el.setAttribute('data-tp-near-footer', '1');
          } else {
            el.removeAttribute('data-tp-near-footer');
          }
        });
      });
    }

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          applyState(e.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
      io.observe(footer);
    } else {
      // Fallback — scroll listener
      function check(){
        var rect = footer.getBoundingClientRect();
        applyState(rect.top < window.innerHeight);
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
